import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { saveStoreConfirmAction } from 'reducks/confirm/actions'
import { setStoreAction } from 'reducks/store/actions'
import { fetchStoreByRef } from 'repos/store'

const fetchStore = (storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    const store = await fetchStoreByRef(storeRef)
    if (!store) return
    dispatch(saveStoreConfirmAction(store))
    dispatch(setStoreAction(store))
  }
}

export default fetchStore
